export default "__VITE_ASSET__BZE2wEwZ__"